var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useRef } from 'react';
import { components } from 'react-select';
import styled from 'styled-components';
import Icon, { IconName } from '../../../Icon';
import useIsOnScreen from '../../../../hooks/useIsOnScreen';
var OptionWithInfo = function (props) {
    var _a = props.data, label = _a.label, description = _a.description;
    var triggerRef = useRef();
    var isOnScreen = useIsOnScreen(triggerRef);
    return (_jsx(components.Option, __assign({}, props, { children: _jsxs(OptionWrapper, __assign({ ref: triggerRef }, { children: [label, _jsx(InfoIcon, { name: IconName.INFO_SQ, description: isOnScreen ? description : null, popperOptions: { strategy: 'fixed' } }, void 0)] }), void 0) }), void 0));
};
export default OptionWithInfo;
var OptionWrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  width: 100%;\n\n  .tooltip-container {\n    max-width: 340px;\n  }\n"], ["\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  width: 100%;\n\n  .tooltip-container {\n    max-width: 340px;\n  }\n"])));
var InfoIcon = styled(Icon)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  font-size: 18px;\n"], ["\n  font-size: 18px;\n"])));
var templateObject_1, templateObject_2;
